//リンクにクラスを追加
export default function (anchors) {
	[].forEach.call(anchors, function(el) {
		if(el.textContent.includes('茅乃舎だし')) {
			el.classList.add('is-kayanoya');
		}
		if(el.textContent.includes('野菜だし')) {
			el.classList.add('is-yasai');
		}
	});
}
